import React, { useState } from 'react'
import axios from 'axios';
import { useEffect } from 'react'
import DefaultPage from '../../Components/DefaultPage';
import RightSidebarGlobal from '../../Components/RightSidebarGlobal';
import FooterCus from '../../Components/FooterCus';
import { BASE_URL } from '../../routes/config';
import Loader from '../../Components/Loader';
import { Margin } from '@mui/icons-material';

function ContactUs() {

  //   const [getPageData, setPageData] = useState([]);

  // let pageDataStore = [];

  // const pageContentData = {
  //     pageTitle: 'Contact Us',
  //     pageContent: getPageData?.body
  //   }
  const [loading, setLoading] = useState(true);
  const [branchLocations_, setBranchLocations] = useState([]);
  const [branchLocations_HeadOffice, setBranchLocationsHeadOffice] = useState([]);

  var resetBranchLoca = [];
 

  const fetchMapdata = async ()=>{
      

    axios.post(`${BASE_URL}/wapi/getbranchdtl`,
      {
        auth_key:"xxxxx",
      }
      ,
      {
          headers: {
            auth_key: "c299cf0ae55ac8a2e3932b65fe5f08538962c5114d5680db8193eb2d3116",
          },
      }
      
      ).then(res => {
        // console.log('rruuuuuuuuurrrr', res);
        if(res.status == '200'){
          
          if(res.data.suc > 0){
            
            // setBranchLocations(res?.data?.msg);
            res?.data?.msg.filter((element, index, aray)=>{
              
              if(element.branch_name != 'Head Office'){
                // console.log(element.branch_name, 'elementelementelementelement');
                resetBranchLoca.push(element)
                setBranchLocations(resetBranchLoca);
                setLoading(false)
              }

              if(element.branch_name == 'Head Office'){
                console.log(element, 'elementelementelementelement');
                // resetBranchLoca.push(element)
                setBranchLocationsHeadOffice(element);
                
              }
              
              
            })
            
            
            // console.log('ttttttttttttttttttt', res?.data?.msg);

            
  
              // pageDataCheck = res.data.status;
          } else {
            setBranchLocations([])
            // pageDataCheck = res.data.status;
          }
    
          }
  
      }) 
  
   }

  

   useEffect(()=>{
    // fetchdata();
    fetchMapdata();
   },[])

  return (
    <>

<div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-12 float-left left_sec searchPageTop contactPage">

    <h1>Our Branch Address</h1>
    
    
    <div className='row'>
    {/* {JSON.stringify(branchLocations_HeadOffice, null, 2)} */}

    {loading ?(
    <div style={{ margin: "0 auto"}}>
		<Loader align = {'center'} gap = {'middle'} size = {'large'} />
    </div>
		):(
      <>
      {branchLocations_HeadOffice && (
      <div className='col-sm-4 float-left box_com'>
      <div className='branchLocaAdd_head'> 
      <h3><i class="fa fa-map-marker" aria-hidden="true"></i>
      {branchLocations_HeadOffice.branch_name}</h3>
      <p>{branchLocations_HeadOffice.addr}</p>
      {branchLocations_HeadOffice?.location_link && (
      <a
      href={`${branchLocations_HeadOffice?.location_link}`} // Replace with your actual route for branch details
      target="_blank" // Opens the link in a new tab
      rel="noopener noreferrer" // Adds security for new tab links
      className="mapPopup_link"// Style the link
      >
      View Map
      </a>
      )}
      </div>
      </div>
      )}

      {branchLocations_.length > 0 ? (
      branchLocations_.map((item)=>(
      <div className='col-sm-4 float-left box_com'>
      <div className='branchLocaAdd'> 
      <h3><i class="fa fa-map-marker" aria-hidden="true"></i>
      {item.branch_name}</h3>
      <p>{item.addr}</p>
      {item?.location_link && (
      <a
      href={`${item?.location_link}`} // Replace with your actual route for branch details
      target="_blank" // Opens the link in a new tab
      rel="noopener noreferrer" // Adds security for new tab links
      className="mapPopup_link"// Style the link
      >
      View Map
      </a>
      )}
      </div>
      </div>
      ))
      ) : (
      <p>No Branches Available.</p>
      )}
      </>
    )}
      

    
    

    </div>



    </div>
    {/* <div class="col-sm-4 float-left">
    <RightSidebarGlobal/>
    </div> */}

    </div>
    </div>

    {/* <FooterCus/> */}

      {/* <DefaultPage pageTitle={pageContentData.pageTitle} pageContent = {pageContentData.pageContent} /> */}
    </>
  )
}

export default ContactUs